import React from 'react'

const ProfileMappingSkeletonLoader = () => {
  return (
    <div>ProfileMappingSkeletonLoader</div>
  )
}

export default ProfileMappingSkeletonLoader